"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationBroadbands = void 0;
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _useRecommendationStatus = require("./useRecommendationStatus");
var _constants = require("../../utils/constants");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
const getSelectedBroadband = () => {
  const selectedBroadband = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectSelectedBroadband);
  const selectedVariant = selectedBroadband.selectedVariant;
  return {
    ...selectedBroadband,
    ...selectedVariant
  };
};
const getBroadband = tier => {
  const broadband = (0, _useAppSelector.useAppSelector)(instanceId => state => (0, _recommendationSelectors.selectBroadband)(state, tier, instanceId));
  if (!broadband) {
    return null;
  }
  return {
    ...broadband
  };
};
const useRecommendationBroadbands = () => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const {
    areBroadbandsPresent
  } = (0, _useRecommendationStatus.useRecommendationStatus)();
  if (!areBroadbandsPresent) {
    return {};
  }
  const recommendedBroadband = getBroadband(_constants.RECOMMENDATION_TIER.RECOMMENDED);
  const premiumBroadband = getBroadband(_constants.RECOMMENDATION_TIER.PREMIUM);
  const budgetBroadband = getBroadband(_constants.RECOMMENDATION_TIER.BUDGET);
  const alternativeBroadband = getBroadband(_constants.RECOMMENDATION_TIER.ALTERNATIVE);
  const alternativePremiumBroadband = !premiumBroadband && alternativeBroadband;
  const alternativeBudgetBroadband = !budgetBroadband && alternativeBroadband;
  const selectedBroadband = getSelectedBroadband();
  const onBroadbandSelect = productId => {
    dispatch((0, _recommendationActions.updateSelectedBroadband)(productId));
  };
  return {
    recommendedBroadband,
    premiumBroadband,
    budgetBroadband,
    alternativePremiumBroadband,
    alternativeBudgetBroadband,
    selectedBroadband,
    onBroadbandSelect
  };
};
exports.useRecommendationBroadbands = useRecommendationBroadbands;